<mat-card class="card1">
<div class="row">
    <div class="col-md-2">
    <img src="{{user.image.url}}" class="profile">
</div>
<div class="col-md-4">
    <div class="col-sm-12">   <h3 class="h3"> {{user.fullname}}</h3>
    </div>
    <div class="col-sm-12">
        Email: {{user.email}}
    </div>
</div>
<div class="col-md-4">
    <div class="col-sm-12"> 
        <h3 class="h3">Phone:{{user.phone}}</h3>
    </div>
    <div class="col-sm-12">
        Address: {{user.address}}
    </div>
</div>
<div class="col-md-2">
    <button mat-button slot="end" class="edit">EDIT PROFILE</button>
</div>
</div>
    
    

</mat-card>
<mat-divider></mat-divider>

<mat-card class="card2">
    <mat-card-header><mat-card-title>
        Past Orders
    </mat-card-title></mat-card-header>
    <mat-divider></mat-divider>
<div class="row rw">
    <div class="col-md-4">
        <div class="col-sm-12">
            Order Date
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
    </div>
    <div class="col-md-4">
        <div class="col-sm-12">
            Order Details
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
    </div>
    <div class="col-md-4">
        <div class="col-sm-12">
            Total Amount
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
        <div class="col-sm-12 det">
            2020
        </div>
    </div>
   
</div>
</mat-card>